import { TransactionQueryKeys } from '@/modules/transaction/keys'
import {
	GetTrueMoneyDepositsParams,
	TrueMoneyDepositsResponse,
} from '@/modules/transaction/types'
import { UnusedSkipTokenOptions } from '@tanstack/react-query'
import BankTransactionService from '../../services'

export const queryTrueMoneyDepositsOptions = (
	payload?: GetTrueMoneyDepositsParams,
	options?: UnusedSkipTokenOptions<TrueMoneyDepositsResponse>,
) => ({
	queryKey: [TransactionQueryKeys.TRUE_MONEY_DEPOSITS, payload],
	queryFn: () => BankTransactionService.getTrueMoneyDeposits(payload),
	...options,
})
